import { Box } from '@material-ui/core'
import img_01 from '../../Assets/layout_images/img_01.svg'
import img_02 from '../../Assets/layout_images/img_02.svg'
import img_03 from '../../Assets/layout_images/img_03.svg'
import img_04 from '../../Assets/layout_images/img_04.svg'
import img_05 from '../../Assets/layout_images/img_05.svg'
import img_06 from '../../Assets/layout_images/img_06.svg'
import {
    HeadingContainer,
    BadgeHeading,
    SectionHeading,
    HeadingDescription,
    GradientText
} from './HeadingComponenents'

import {
    HeadingGradientShift,
    HeadingScaleGlow,
    HeadingUnderline,
    HeadingGradientUnderline
} from './Headinghovercomponents'

export default function WhyNeedUsHome() {
    return (
        <div className="why_need_us_home">
            <div>
                <HeadingContainer>
                    <HeadingGradientShift>
                        <SectionHeading>
                            Learn, Track and <GradientText>Grow</GradientText>
                        </SectionHeading>
                    </HeadingGradientShift>
                    <HeadingDescription>
                        Beyond teaching, we ensure that students learn.Experience the power of One-on-One teaching, amplified by AI.
                    </HeadingDescription>
                </HeadingContainer>
                

                <Box className="student_need_home">
                    <div className="student_need_points_home">
                        {[
                            ['1 on 1 Live Tuition Classes', img_01],
                            ['Monthly HybridAI Exam:Target weak areas and get revisions', img_02],
                            [
                                'Parent Portal with Progress tracker',
                                img_03
                            ],
                            ['Flexible Time-table: School, tuition, revision, and fun', img_04],
                            ['“Meet Your Academic Friend” - Free Monthly Counselling Sessions', img_05],
                            ['Select Your Tutor Option', img_06]
                        ].map((el, key) => (
                            <div
                                key={key}
                                className={`student_need_point_home_text${
                                    key % 2 === 0 ? 1 : 2
                                }`}
                            >
                                <div>
                                    <p className="font-Quick font-med">
                                        {el[0]}
                                    </p>
                                    <img src={el[1]} alt={el[0]} />
                                </div>
                            </div>
                        ))}
                    </div>
                </Box>
            </div>
        </div>
    )
}
